import { useEffect, useState } from 'react';
import { getLocale, setLocale, subscribe, type Locale } from '../i18n';

const locales: Array<{ code: Locale; name: string; icon: string }> = [
    { code: 'de', name: 'Deutsch', icon: '/flags/de.svg' },
    { code: 'en', name: 'English', icon: '/flags/en.svg' },
    { code: 'pl', name: 'Polski', icon: '/flags/pl.svg' }
];

export default function LanguageSwitcher() {
    const [locale, setLocal] = useState<Locale>(getLocale());

    useEffect(() => subscribe(setLocal), []);

    return (
        <div className="flex items-center gap-1" aria-label="Sprache wechseln">
            {locales.map(({ code, icon, name }) => (
                <button
                    key={code}
                    className={[
                        'inline-flex items-center justify-center px-2 py-1 rounded-md border transition-colors',
                        locale === code ? 'border-slate-300 bg-white shadow-sm' : 'border-transparent hover:bg-slate-100'
                    ].join(' ')}
                    onClick={() => setLocale(code)}
                    title={name}
                    aria-label={name}
                    aria-pressed={locale === code}
                    type="button"
                >
                    <img
                        src={icon}
                        alt=""
                        aria-hidden="true"
                        className="block h-4 w-6 box-border border border-slate-600"
                        width={24}
                        height={16}
                        loading="lazy"
                        decoding="async"
                    />
                </button>
            ))}
        </div>
    );
}
